import { io } from 'socket.io-client'

const socket = io('/', { withCredentials: true })

export default {
  install: (app) => {
    app.config.globalProperties.$socket = socket
    app.provide('socket', socket)
  },
  socket
}